import { styled, keyframes } from "styled-components";

export const Container = styled.div`
    transition: ${props=>props.theme.animationTime.short}s all ease;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background: ${props=>props.theme.colors.background};
    overflow: hidden;
    color: ${props=>props.theme.colors.text};
    @media screen and (max-width: ${props=>props.theme.breakpoint}px){
        flex-direction: column;
        overflow: auto;
        overflow-x: hidden;
    }
`;

export const AnalyticsContainerIntro = keyframes`
    0%{
        opacity: 0;
    }
    40%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
`;

export const AnalyticsAndTopContainer = styled.div`
    display: flex;
    margin: auto;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    z-index: 1;
    animation: ${AnalyticsContainerIntro} ${props=>props.theme.animationTime.medium}s;
    @media screen and (max-width: ${props=>props.theme.breakpoint}px){
        
    }
`;


export const AnalyticsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 100%;
    animation: ${AnalyticsContainerIntro} ${props=>props.theme.animationTime.medium}s;
    @media screen and (max-width: ${props=>props.theme.breakpoint}px){
        width: 100%;
        justify-content: center;
        padding-top: 10vh;
    }
`;